
/* eslint-disable */
<template>
  <div>
    <AiDialog class="progress-dialog"
              width="80%"
              height="80%"
              :visible.sync="visible"
              @close="onClose"
    >
      <div slot="header" class="progress-dialog__header">
        测试视频
      </div>
      <div class="create-sub-dialog__creatARcontent modal">
        <div class="topbutton">
          <div class="ai-button ai-button--primary new-sub-account actions__add-btn add-button"
               @click="handleAddTest"
          >
            添加测试
          </div>
          <!-- <el-link class="upload-demo"
                   v-if="itemData.tvUrl"
                   :href="itemData.tvUrl"
                   target="_blank"
          >
            tv-url
          </el-link> -->
          <el-upload
            class="upload-demo"
            action="/admin/ar/tv_data"
            :data="uploadData"
            :file-list="fileList"
            :show-file-list="false"
            v-loading="fileUpLoading"
            :disabled="fileUpLoading"
            :on-progress="handleProgress"
            :on-success="handleSuccess"
          >
            <el-tooltip class="item"
                        effect="dark"
                        placement="top-start"
                        :disabled="true"
            >
              <el-button size="mini" type="primary">
                上传真值
              </el-button>
            </el-tooltip>
          </el-upload>
          <!-- <el-button v-else class="create-truth" @click="uploadTruth">
            上传真值
          </el-button> -->
        </div>
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>场名称</th>
                <th>AR ID</th>
                <th>UID</th>
                <th>状态</th>
                <th>详情</th>
                <th>更新时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in subaccounts" :key="index">
                <td style="width:10%">
                  {{ item.name }}
                </td>
                <td style="width:20%">
                  {{ item.ar_id }}
                </td>
                <td style="width:15%">
                  {{ item.uid }}
                </td>
                <td style="width:5%">
                  {{ item.status_verbose }}
                </td>
                <td style="width:10%">
                  {{ item.stage_verbose }}
                </td>
                <td style="width:10%">
                  {{ item.updated | timeFormatter }}
                </td>
                <td style="width:30%" width="30%">
                  <div class="ai-button ai-button--text ai-button--text--primary"
                       style="margin-right:10px;"
                       @click="DoPipeline(item)"
                  >
                    {{ActivityText(item)}}
                  </div>
                  <div class="ai-button ai-button--text ai-button--text--danger"
                       style="margin-right:10px;"
                       @click="DEL(item)"
                  >
                    删除
                  </div>
                  <div class="ai-button ai-button--text ai-button--text--primary"
                       style="margin-right:10px;"
                       @click="showDetail(item)"
                  >
                    详情
                  </div>
                  <el-button v-if="item.stage_verbose !== '已完成'" @click="createTruth(item,index)">
                    {{item.createStatus?"处理中":"生成真值"}}
                  </el-button>
                  <el-button v-else @click="ppDialog(item.dialog)">
                    {{item.createStatus}}
                  </el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <AiPagination v-model="currentPage"
                      class="pagination"
                      :total-page-count="totalPageCount"
                      @change="getData"
        />
      </div>
    </AiDialog>
    <FileUpload
      :post-type = "2"
      :visible="uploadVisible"
      :item-data="itemData"
      @close="closeFileDialog"
      @finishUpload="onFinishUpload"
    />
    <AiDialog class="progress-dialog"
              width="90%"
              height="80%"
              :visible.sync="detailVisible"
              @close="closedetailDialog"
    >
      <div slot="header" class="progress-dialog__header">
        详情
      </div>

      <div class="create-sub-dialog__creatARcontent modal">
        <!-- <div class="vr-replay" v-if="currentVideoReplayVrId && currentVideoReplayImage && currentVideoReplayImage.length">
          <div class="vr-replay__image-wrapper" ref="vrReplayContainer">
            <img class="vr-replay__image" :src="currentVideoReplayImage" alt="">
          </div>
          <div class="vr-replay__info">
            <div class="ai-button vr-replay__button" @click="switchVideoReplayItem(currentVideoReplayImageIndex - 1)">
              上一张
            </div>
            <span class="vr-replay__text">
              当前 {{currentVideoReplayImageIndex + 1}} / {{currentVideoReplayImageCount}} 张, 成功 {{ currentVideoReplaySuccess }} 张, 成功率 {{ ((currentVideoReplaySuccess / currentVideoReplayImageCount) * 100).toFixed(2) }}%
            </span>
            <div class="ai-button vr-replay__button" @click="switchVideoReplayItem(currentVideoReplayImageIndex + 1)">
              下一张
            </div>
            <!-- eslint-disable-next-line -->
        <!-- <div class="vr-replay__text-info">{{ currentVideoReplayInfo }}</div>
          </div>
        </div> -->
        <div class="detailText">
          <div class="detailtxt">
            <el-link style="margin-left:20px;"
                     v-if="detailText.tv_url"
                     :href="detailText.tv_url"
                     target="_blank"
            >
              点击下载{{detailText.tv_url}}
            </el-link>
          </div>

          <div class="detailtxt">
            {{'id: '+ detailText.id}}
          </div>
          <div class="detailtxt">
            {{'name: '+ detailText.name}}
          </div>
          <div class="detailtxt">
            {{'uid: '+ detailText.uid}}
          </div>
          <div class="detailtxt">
            {{'ar_id: '+ detailText.ar_id}}
          </div>
          <div class="detailtxt">
            {{'dynamic_angle_error: '+ detailText.dynamic_angle_error}}
          </div>
          <div class="detailtxt">
            {{'dynamic_range_error: '+ detailText.dynamic_range_error}}
          </div>
          <div class="detailtxt">
            {{'dynamic_success_rate_verbose: '+ detailText.dynamic_success_rate_verbose}}
          </div>
          <div class="detailtxt">
            {{ 'result_url: '+ detailText.result_url }}
          </div>
          <div v-for="(token, index) in tokenList" class="detailtxt">
            {{ `replay token ${index}: `+ token }}
          </div>
          <div class="detailtxt">
            {{'localizer_map:'}}
            <a :href="detailText.result_url+'/localizer_map.jpg'" target="_blank" >
              {{ detailText.result_url+'/localizer_map.jpg' }}
            </a>
          </div>
          <div class="detailtxt">
            {{'localizer_map5:'}}
            <a :href="detailText.result_url+'/localizer_map_5.jpg'" target="_blank" >
              {{ detailText.result_url+'/localizer_map_5.jpg' }}
            </a>
          </div>
          <div class="detailtxt">
            {{'video:'}}
            <a :href="detailText.videos" target="_blank" >
              {{ detailText.videos }}
            </a>
          </div>
          <div class="detailtxt">
            {{'stage_verbose: '+ detailText.stage_verbose}}
          </div>
          <div class="detailtxt">
            {{'static_angle_error: '+ detailText.static_angle_error}}
          </div>
          <div class="detailtxt">
            {{'static_locating_time: '+ detailText.static_locating_time}}
          </div>
          <div class="detailtxt">
            {{'static_range_error: '+ detailText.static_range_error}}
          </div>
          <div class="detailtxt">
            {{'static_success_rate_verbose: '+ detailText.static_success_rate_verbose}}
          </div>
          <div class="detailtxt">
            {{'status_verbose: '+ detailText.status_verbose}}
          </div>
          <div class="detailtxt">
            {{'updated: '+ detailText.updated}}
          </div>
        </div>
      </div>
    </AiDialog>
    <el-dialog title="详情" :visible.sync="ppVisible">
      <div v-html="ppContent" class="ppContent"></div>
      <el-footer>
        <el-button @click="closePp">
          取消
        </el-button>
      </el-footer>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import moment from 'moment';
import axios from 'axios';
// import * as THREE from 'three';

const createSuccess = require('@/assets/views/users/create_success.svg');
const deleteSuccess = require('@/assets/views/users/delete_success.svg');

export default {
  filters: {
    timeFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  name: 'upload',
  props: {
    itemData: { type: Object, default: null },
    itemNum: { type: Number, default: 0 },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileUpLoading: false,
      fileList: [],
      ppVisible: false,
      ppContent: '',
      currentEditItem: null,
      detailVisible: false,
      subaccounts: [],
      totalPageCount: 20,
      currentPage: 1,
      uploadVisible: false,
      detailText: '',
      tokenList: [],
      currentVideoReplayList: [],
      currentVideoReplayImageIndex: 0,
      currentVideoReplayImageCount: 0,
      currentVideoReplayImage: '',
      currentVideoReplayInfo: '',
      currentVideoReplaySuccess: 0,
      currentVideoReplayVrId: null,
    };
  },
  computed: {
    uploadData() {
      return { ar_id: this.itemData && this.itemData.ar_id };
    },
    // uploadData: { ar_id: this.itemData.ar_id },
  },
  watch: {
    itemData(val) {
      if (val === null) return;
      console.log('itemData:    ', val);
      this.getData();
    },
  },
  mounted() {
    // console.log(this.itemData + "{apiAddress}/admin/ar/location?ar_id=&uid=");
    // this.getData();
    console.log(this.itemData, '+++++++++++++++++++++++++++++++=');
  },
  methods: {
    handleProgress() {
      this.fileUpLoading = true;
    },
    async handleSuccess(res, file, fileList) {
      this.fileList = fileList;
      console.log(res, file, fileList, 'file,fileListfile,fileList');
      this.fileUpLoading = false;
      this.$message({ message: res.error_msg });
      const params = { name: 'test', ar_id: this.itemData.ar_id };
      await this.$http.post('/admin/ar/location', params);
      this.getData();
    },
    closePp() {
      this.ppVisible = false;
      this.ppContent = '';
    },
    ppDialog(c) {
      console.log(c, typeof c, 'this.ppContentthis.ppContentthis.ppContentthis.ppContentthis.ppContent');
      this.ppContent = c;

      this.ppVisible = true;
    },
    async createTruth(item, i) {
      console.log(item, 'tttt');
      if (item.createStatus) {
        this.$message({ message: '正在处理中' });
        return;
      }
      try {
        const res = await axios.post('/admin/ar/tv_pipeline', { ar_id: item.ar_id, location_uid: item.uid });
        const { data: { data: { result } } } = await axios.get(`/admin/ar/tv?location_uid=${item.uid}`);
        console.log(res, result, '<<<<<<<<resss');
        const l = result.length - 1;
        this.subaccounts.splice(i, 1, {
          ...item, stage_verbose: result[l] && result[l].stage_verbose, createStatus: result[l] && result[l].stage_verbose, dialog: result[l] && JSON.stringify(result[l].meta_data),
        });
        console.log(this.subaccounts, 'this.subaccountsthis.subaccountsthis.subaccountsthis.subaccounts');
      } catch (e) {
        console.log(e);
      }
    },

    disposeCurrentVideoReplayVR() {},
    refreshVideoReplayVR() {
      this.disposeCurrentVideoReplayVR();

      // this.vrScene = new THREE.Scene();
      // this.vrRenderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    },
    async getTestVideoReplayData() {
      // https://robot-vr.aibee.cn/admin/ar/location?uid=6ddeb094-59cc-49a3-ae87-ea87babcef6c
      // https://robot-vr.aibee.cn/admin/ar?ar_id=9933d0ea-4186-41d6-b26b-137236fb0127
      const { data: videoDetailData } = await axios.get(`/admin/ar?ar_id=${this.detailText.ar_id}`);
      if (videoDetailData.error_no !== 200 || videoDetailData.data.result.length === 0) return;
      this.currentVideoReplayVrId = videoDetailData.data.result[0].vr_id;
      this.refreshVideoReplayVR();
    },
    switchVideoReplayItem(index) {
      if (index >= this.currentVideoReplayList.length || index < 0) return;
      const item = this.currentVideoReplayList[index];
      this.currentVideoReplayImageIndex = index;
      this.currentVideoReplayImage = `${this.detailText.result_url}/extract-frame/${item[0]}`;
      this.currentVideoReplayInfo = JSON.stringify(
        {
          success: item[1],
          quat: [item[2][3], item[2][0], item[2][1], item[2][2]],
          pos: item[3],
        },
        null,
        2
      );
    },
    async showDetail(item) {
      this.detailVisible = true;
      console.log('showDetail', item);
      this.detailText = item;
      this.tokenList = [];

      try {
        const folder = item.result_url.substring(0, item.result_url.lastIndexOf('/'));
        const tokenFile = `${folder}/token.txt`;

        const { data: tokenListString } = await axios.get(tokenFile);
        const tokenList = tokenListString.split('\n').filter(s => s.length > 0);

        this.$set(this, 'tokenList', tokenList);
      } catch (e) {
        console.error(e);
      }

      // this.detailText.dynamicResult =

      // try {
      //   const dynamicResultUrl = `${item.result_url}/dynamic_result.access`;
      //   const { data: dynamicResultData } = await axios.get(dynamicResultUrl);
      //   const dynamicResultList = dynamicResultData.split('\n').map((s) => {
      //     const list = s.split(' ');
      //     const quat = [Number(list[2]), Number(list[3]), Number(list[4]), Number(list[1])];
      //     const pos = [Number(list[5]), Number(list[6]), Number(list[7])];
      //     const success = list[8] === 'True';
      //     return [list[0], success, quat, pos];
      //   });
      //   // console.log(dynamicResultList);
      //   this.currentVideoReplayList = dynamicResultList;
      //   this.currentVideoReplayImageCount = this.currentVideoReplayList.length;
      //   this.currentVideoReplaySuccess = dynamicResultList.filter(i => i[1]).length;
      //   // await this.getTestVideoReplayData();
      //   // this.switchVideoReplayItem(0);
      // } catch (e) {
      //   console.log(e);
      // }
    },
    async getData() {
      console.log('------getData--------------------', this.itemData);

      const str = `/admin/ar/location?ar_id=${this.itemData.ar_id}&page_size=14`;
      try {
        const { data: { data } } = await this.$http.get(str);
        console.log('------data--------------------', data);
        if (data) {
          this.subaccounts = data.result;
          this.currentPage = data.pageNum;
          this.totalPageCount = data.pageCount;
          // eslint-disable-next-line no-restricted-syntax const item of data.result
          for (let i = 0; i < data.result.length; i++) {
            const item = data.result[i];
            if (item.stage_verbose === '已完成') {
              axios.get(`/admin/ar/tv?location_uid=${item.uid}`).then((res) => {
                const { data: { data: { result } } } = res;
                const l = result.length - 1;
                const createStatus = result[l] ? result[l].stage_verbose : '处理中';
                const dialog = JSON.stringify(result[l]);
                this.subaccounts.splice(i, 1, { ...item, createStatus, dialog });
              });
            }
          }


          // this.subaccounts = await data.result.map(async (item, index) => {
          //   if (item.stage_verbose === '已完成') {
          //     const { data: { data: { result: [stage_verbose, meta_data] } } } = await axios.get(`/admin/ar/tv?location_uid=${item.uid}`);

          //     item.createStatus = stage_verbose;
          //     item.dialog = meta_data;
          //     return item;
          //   }
          //   return item;
          // });
          console.log(this.subaccounts, 'this.subaccountsthis.subaccountsthis.subaccounts');
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    closeFileDialog() {
      this.uploadVisible = false;
    },
    handleAddTest() {
      this.uploadVisible = true;
    },
    async creatNewVideo(url, ar_id = this.itemData.ar_id) {
      const params = { name: 'test', ar_id: this.itemData.ar_id, url:  this.videoUrl};
      const { data } = await this.$http.post('/admin/ar/mobile_location', params);
      console.log(data);
      this.$emit('update:itemData', data.data);
      // this.itemData = data.data;
      // this.uploadVisible = true;
    },
    DEL(item) {
      this.currentEditItem = item;
      this.$confirm({
        title: '确认要删除这组数据吗?',
        message: '删除将会终止正在进行的处理工作，且无法恢复!',
      }).then(() => {
        this.deleteSubAccount();
      }).catch(() => {});
    },
    async deleteSubAccount(id) {
      const qstr = `/admin/ar/location/${this.currentEditItem.uid}`;
      const { data } = await this.$http.delete(qstr);
      if (data && data.error_no === 200) {
        this.$message.basic({
          message: '删除成功!',
          icon: createSuccess,
        });
        this.getData();
      }
    },
    closedetailDialog() {
      this.detailVisible = false;
    },
    onClose() {
      // this.itemData = null;
      this.$emit('close');
    },
    async onFinishUpload(url) {
      this.videoUrl = url;
      await this.creatNewVideo();
      this.uploadVisible = false;
    },
    ActivityText(item) {
      // console.log(item.videos.length);
      if (item.status_verbose === 'running') {
        item.editstauts = 3;
        return '停止处理';
      }
      if (item.status_verbose === 'stopped' || item.status_verbose === 'success' || item.status_verbose === 'error') {
        item.editstauts = 4;
        return '重跑数据';
      }
      if (item.status_verbose === 'ready') {
        item.editstauts = 2;
        return '处理数据';
      }
    },
    DoPipeline(item) {
      this.currentEditItem = item;
      switch (item.editstauts) {
        case 2: {
          //  console.log('处理数据');
          this.sloveData();
        }
          break;
        case 3: {
          //  console.log('暂停处理');
          this.putSloveData();
        }
          break;
        case 4: {
          //  console.log('重跑数据');
          this.reDo(item);
        }
          break;
        default: break;
      }
    },
    async putSloveData() {
      const str = `/admin/ar/location_pipeline/${this.currentEditItem.uid}`;
      try {
        const { data: { data } } = await this.$http.put(str);
        setTimeout(() => {
          this.getData();
        }, 2000);
      } catch (e) {

      }
    },
    async sloveData() {
      const str = `/admin/ar/location_pipeline/${this.currentEditItem.uid}`;
      try {
        const { data: { data } } = await this.$http.post(str);
        setTimeout(() => {
          this.getData();
        }, 2000);
      } catch (e) {

      }
    },
    reDo(item) {
      this.currentEditItem = item;
      this.$confirm({
        title: '确认要重跑这组数据吗?',
        message: '改组数据已经生成，重跑会覆盖原有数据!',
      }).then(() => {
        this.sloveData();
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ppContent{
  height:400px;
  overflow: auto;
  white-space: pre-wrap;
}
.upload-demo{
  position: absolute;
    right: 200px;
    /deep/ .circular{
      width:22px!important
    }
}
.vr-replay {
  width: 100%;
  display: flex;
  padding: 10px;
  box-sizing: border-box;

  &__image-wrapper {
    width: 300px;
  }

  &__image {
    width: 300px;
  }

  &__info {
    flex: 1;
    margin-left: 10px;
  }

  &__button {
    // display: inline-flex;
    padding: 2px 8px;
  }

  &__text-info {
    white-space: pre;
    padding: 16px;
    box-sizing: border-box;
  }
}

.modal {
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding: 0 0 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.progress-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }


  &__content {
    display: block;
    padding: 20px 16px;
  }

  &__loadingdiv{
    padding: 20px;
  }
}

/deep/ .upload-area{
    display: block;
    align-items: center;
    height: 100%;
    margin-top: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
}
/deep/ .uploadWrap {
  height: 30vh;
}

/deep/ .upload {
  height: 100%;
}
/deep/ .imgWrap > div .name {
    text-overflow: initial;
    white-space:pre-wrap;
}
/deep/ .imgWrap {
    word-break: break-all;
}

.table-wrapper {
  margin: 0 40px;
  flex: 1;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  word-break: keep-all;
  tr {
    height: 50px;
  }

  th {
    border: 0;
    font-size: 14px;
    color: #888;
  }

  thead {
    th {
      background-color: #ddeffb;

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
      }
    }
  }

  tbody {
    td {
      background-color: white;
      border-bottom: 1px solid #eee;
    }

    tr:last-child td {
      border-bottom: 0;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 4px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 4px;
    }
  }

  td {
    text-align: center;
    color: #888;
    font-size: 14px;
  }
}

.actions {
  margin: 0 40px;
  width: 0px;

  &__right {
    margin-right: 40px;
  }

  &__left-tilte {
    margin-left: 40px;
    font-family:"微软雅黑";
    font-size: 24px;
    color: #888;
  }

  &__add-btn {

    width: 89px;
    height: 22px;
    font-size: 11px;
    margin-left: 12px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }
  }

  &__search-input {
    width: 183px;
    height: 22px;
  }

  &__search-btn {
    width: 22px;
    height: 22px;

    .material-icons {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
}

.detailtxt{
  margin-left: 10px;
  margin-top: 15px;
}

.topbutton{
  // margin-left: 88%;
  margin-top: 10px;
  // margin-right: 120px;
  margin-bottom: 10px;
  height: 24px;
  position: relative;
}
.add-button {
  position: absolute;
  right: 80px;
}
</style>
